import { ReactNode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { SWProvider } from "@/context";
import { configureLogoutService } from "@/Services/Logout";
import ErrorBoundary from "@/shared/feedback/ErrorBoundary";
import { persistor, store } from "@/store";

configureLogoutService({
    dispatch: store.dispatch,
    flushPersistor: () => persistor.flush(),
});

const Root = ({ children }: { children: ReactNode }) => {
    return (
        <SWProvider>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <HelmetProvider>
                        <ErrorBoundary>{children}</ErrorBoundary>
                    </HelmetProvider>
                </PersistGate>
            </Provider>
        </SWProvider>
    );
};

export default Root;
